export default __webpack_public_path__ + "static/media/185.2e3f5017.png";